export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About Us",
      gallery: "Gallery",
      reviews: "Reviews",
      contact: "Contact"
    },
    common: {
      callNow: "Call Now",
      contactUs: "Contact Us",
      getQuote: "Get a Free Quote",
      requestQuote: "Request Quote",
      bookAppointment: "Book Appointment",
      readMore: "Read More",
      viewMore: "View More",
      viewGoogleReviews: "View Google Reviews",
      privacy: "Privacy Policy",
      terms: "Terms of Use"
    },
    hero: {
      title: "Windshield Repair & Replacement in Dorval",
      subtitle: "Fast, reliable auto glass service for Montreal, Dorval, and the West Island. We help with repairs, replacements, and insurance claims."
    },
    trust: {
      local: "Local Dorval Business",
      insurance: "Insurance Claim Assistance",
      fast: "Fast, Same-Day Service",
      specialists: "Auto Glass Specialists"
    },
    services: {
      title: "Our Auto Glass Services",
      subtitle: "Comprehensive solutions for all your vehicle glass needs.",
      items: {
        replacement: {
          title: "Windshield Replacement",
          desc: "OEM-quality glass installed by certified technicians for ultimate safety."
        },
        repair: {
          title: "Stone Chip Repair",
          desc: "Quick and durable structural resin repairs to prevent further cracking."
        },
        side: {
          title: "Side Window Glass",
          desc: "Fast replacement of shattered door glass, including debris cleanup."
        },
        rear: {
          title: "Rear Window Replacement",
          desc: "Expert installation of rear glass, including defrost element connections."
        },
        sunroof: {
          title: "Sunroof Glass",
          desc: "Specialized replacement for panoramic roofs and standard sunroofs."
        },
        insurance: {
          title: "Insurance Claims",
          desc: "We handle the paperwork directly with your insurance company."
        }
      }
    },
    garageServices: {
      title: "Additional Garage Services",
      subtitle: "Book essential maintenance and tire services at our Dorval garage.",
      badge: "Appointment booking available",
      appointmentNote: "Appointment booking only",
      payAtGarage: "Pay at the garage",
      trustSignals: [
        "Free 2-year road hazard protection on eligible services",
        "TPMS sensors available for compatible vehicles",
        "Tire installation is booked online and paid at the garage"
      ],
      sections: {
        maintenance: {
          title: "Maintenance",
          items: [
            "Oil change service",
            "Brake inspection"
          ]
        },
        tires: {
          title: "Tire Installation Booking",
          desc: "Installation appointments available for 13\" to 24\" tires.",
          sizes: [
            "13\" tire installation",
            "14\" tire installation",
            "15\" tire installation",
            "16\" tire installation",
            "17\" tire installation",
            "18\" tire installation",
            "19\" tire installation",
            "20\" tire installation",
            "21\" tire installation",
            "22\" tire installation",
            "23\" tire installation",
            "24\" tire installation"
          ]
        },
        hardware: {
          title: "Hardware & Protection",
          items: [
            "Chrome nuts / bolts hardware kit",
            "Black nuts / bolts hardware kit",
            "Add lock nuts / bolts",
            "TPMS sensors",
            "Free 2-year road hazard protection"
          ],
          tpms: "TPMS sensors",
          restriction: "Some restrictions apply."
        }
      }
    },
    insuranceSection: {
      title: "Hassle-Free Insurance Claims",
      desc: "Dealing with a broken windshield is stressful enough. We work directly with major Quebec insurance providers to process your claim smoothly. Just bring us your policy details, and we'll handle the rest.",
      bullet1: "Direct billing to your insurance",
      bullet2: "Deductible assistance available",
      bullet3: "No complex paperwork for you"
    },
    whyUs: {
      title: "Why Choose Elite?",
      features: [
        "Local auto glass experts",
        "Fast turnaround times",
        "Quality workmanship guaranteed",
        "Friendly, professional service",
        "Easy quote requests",
        "Convenient Dorval location"
      ]
    },
    areas: {
      title: "Proudly Serving",
      desc: "Dorval, Montreal, Lachine, Pointe-Claire, West Island, Laval, and surrounding regions."
    },
    cta: {
      title: "Need auto glass repair today?",
      subtitle: "Contact us now to schedule your appointment or get a free estimate."
    },
    contactPage: {
      title: "Contact Us",
      subtitle: "Get in touch for a quote or to schedule your service.",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Email Address",
        vehicle: "Vehicle Make / Model / Year",
        issue: "Type of Glass Issue",
        tireSize: "Tire Size",
        selectTireSize: "Select tire size",
        insurance: "Is this an insurance claim?",
        yes: "Yes",
        no: "No",
        other: "Other",
        message: "Additional Details",
        submit: "Send Request",
        success: "Message sent! We will contact you shortly."
      }
    },
    aboutPage: {
      title: "About Vitres D'Autos Elite",
      p1: "Located in the heart of Dorval, Vitres D'Autos Elite has been providing top-tier auto glass services to the Montreal and West Island communities for years.",
      p2: "Our mission is simple: deliver safe, fast, and high-quality windshield repair and replacement while making the process as stress-free as possible for our customers. We understand that a broken window is an unexpected hassle, which is why we offer seamless insurance claim assistance and efficient service."
    },
    galleryPage: {
      title: "Our Work Gallery",
      subtitle: "See the quality of our auto glass replacements and repairs.",
      before: "Before",
      after: "After",
      openProject: "View Project",
      close: "Close",
      cases: [
        {
          title: "Windshield Crack Repair",
          location: "Dorval, Quebec",
          desc: "A spreading windshield crack was stabilized and repaired before it could compromise visibility or require a full replacement.",
          tags: ["Windshield", "Stone Chip", "Safety"]
        },
        {
          title: "Side Window Replacement",
          location: "Montreal, Quebec",
          desc: "Broken door glass was replaced, loose debris was cleaned out, and the window track was checked for smooth operation.",
          tags: ["Side Glass", "Cleanup", "Replacement"]
        },
        {
          title: "Tire Service Appointment",
          location: "West Island, Quebec",
          desc: "Seasonal tire installation booked at the garage with hardware and TPMS options reviewed before service.",
          tags: ["Tires", "TPMS", "Garage"]
        },
        {
          title: "Rear Glass Replacement",
          location: "Lachine, Quebec",
          desc: "Damaged rear glass was replaced and the vehicle was cleaned carefully before pickup.",
          tags: ["Rear Glass", "Cleanup", "Replacement"]
        },
        {
          title: "Sunroof Glass Service",
          location: "Pointe-Claire, Quebec",
          desc: "A sunroof glass issue was inspected and prepared for a clean, safe replacement appointment.",
          tags: ["Sunroof", "Inspection", "Glass"]
        },
        {
          title: "Wheel Hardware Upgrade",
          location: "Dorval, Quebec",
          desc: "Hardware options were reviewed with the client, including lock nuts, black bolts, and TPMS availability.",
          tags: ["Hardware", "TPMS", "Wheels"]
        }
      ]
    },
    reviewsPage: {
      title: "Customer Reviews",
      subtitle: "See what our clients in Montreal and the West Island have to say."
    },
    map: {
      title: "Find Vitres D'Autos Elite",
      openGoogle: "Open in Google Maps"
    },
    legal: {
      privacyTitle: "Privacy Policy",
      termsTitle: "Terms of Use",
      updated: "Last updated: June 12, 2026",
      privacyIntro: "Vitres D'Autos Elite respects your privacy. This policy explains how basic contact and appointment information may be collected when you request a quote or service.",
      privacyItems: [
        "We may collect your name, phone number, email, vehicle details, requested service, and message details.",
        "We use this information to respond to quote requests, schedule appointments, and provide customer service.",
        "We do not sell personal information. Information may be shared only with service providers when needed to operate the business.",
        "To request an update or deletion of your information, contact us using the phone or email listed on this website."
      ],
      termsIntro: "By using this website, you agree to these basic terms for browsing, quote requests, and appointment inquiries.",
      termsItems: [
        "Website content is provided for general information and may change without notice.",
        "Submitting a form does not confirm an appointment until the business contacts you.",
        "Prices, availability, road hazard protection, and hardware options may vary by vehicle, tire size, and service requirements.",
        "External links, including Instagram and Google, are provided for convenience and are governed by their own terms."
      ]
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À Propos",
      gallery: "Galerie",
      reviews: "Avis",
      contact: "Contact"
    },
    common: {
      callNow: "Appeler Maintenant",
      contactUs: "Contactez-Nous",
      getQuote: "Obtenir une Soumission",
      requestQuote: "Demander une Soumission",
      bookAppointment: "Prendre Rendez-vous",
      readMore: "Lire la Suite",
      viewMore: "Voir Plus",
      viewGoogleReviews: "Voir les Avis Google",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation"
    },
    hero: {
      title: "Réparation et Remplacement de Pare-brise à Dorval",
      subtitle: "Service de vitres d'auto rapide et fiable pour Montréal, Dorval et l'Ouest-de-l'Île. Nous aidons avec les réparations, remplacements et réclamations d'assurance."
    },
    trust: {
      local: "Entreprise Locale de Dorval",
      insurance: "Aide aux Réclamations d'Assurance",
      fast: "Service Rapide le Jour Même",
      specialists: "Spécialistes en Vitres d'Auto"
    },
    services: {
      title: "Nos Services de Vitres d'Auto",
      subtitle: "Des solutions complètes pour tous vos besoins en vitrerie automobile.",
      items: {
        replacement: {
          title: "Remplacement de Pare-brise",
          desc: "Verre de qualité OEM installé par des techniciens certifiés pour une sécurité optimale."
        },
        repair: {
          title: "Réparation d'Éclats de Pierre",
          desc: "Réparations rapides et durables à la résine structurelle pour prévenir les fissures."
        },
        side: {
          title: "Vitres Latérales",
          desc: "Remplacement rapide des vitres de portes brisées, incluant le nettoyage des débris."
        },
        rear: {
          title: "Remplacement de Lunette Arrière",
          desc: "Installation experte de la vitre arrière, incluant la connexion du dégivreur."
        },
        sunroof: {
          title: "Toit Ouvrant",
          desc: "Remplacement spécialisé pour toits panoramiques et toits ouvrants standards."
        },
        insurance: {
          title: "Réclamations d'Assurance",
          desc: "Nous gérons la paperasse directement avec votre compagnie d'assurance."
        }
      }
    },
    garageServices: {
      title: "Services de Garage Additionnels",
      subtitle: "Prenez rendez-vous pour l'entretien essentiel et les services de pneus à notre garage de Dorval.",
      badge: "Prise de rendez-vous disponible",
      appointmentNote: "Sur rendez-vous seulement",
      payAtGarage: "Payable au garage",
      trustSignals: [
        "Protection gratuite de 2 ans contre les risques routiers sur les services admissibles",
        "Capteurs TPMS disponibles pour les véhicules compatibles",
        "L'installation de pneus est réservée en ligne et payable au garage"
      ],
      sections: {
        maintenance: {
          title: "Entretien",
          items: [
            "Service de changement d'huile",
            "Inspection des freins"
          ]
        },
        tires: {
          title: "Installation de Pneus",
          desc: "Rendez-vous disponibles pour l'installation de pneus de 13\" à 24\".",
          sizes: [
            "Installation de pneus 13\"",
            "Installation de pneus 14\"",
            "Installation de pneus 15\"",
            "Installation de pneus 16\"",
            "Installation de pneus 17\"",
            "Installation de pneus 18\"",
            "Installation de pneus 19\"",
            "Installation de pneus 20\"",
            "Installation de pneus 21\"",
            "Installation de pneus 22\"",
            "Installation de pneus 23\"",
            "Installation de pneus 24\""
          ]
        },
        hardware: {
          title: "Quincaillerie et Protection",
          items: [
            "Ensemble d'écrous / boulons chrome",
            "Ensemble d'écrous / boulons noirs",
            "Ajout d'écrous / boulons antivol",
            "Capteurs TPMS",
            "Protection gratuite de 2 ans contre les risques routiers"
          ],
          tpms: "Capteurs TPMS",
          restriction: "Certaines restrictions s'appliquent."
        }
      }
    },
    insuranceSection: {
      title: "Réclamations d'Assurance Sans Tracas",
      desc: "Faire face à un pare-brise cassé est assez stressant. Nous travaillons directement avec les principaux assureurs du Québec pour traiter votre réclamation en douceur. Apportez-nous les détails de votre police, et nous nous occupons du reste.",
      bullet1: "Facturation directe à votre assurance",
      bullet2: "Assistance pour la franchise disponible",
      bullet3: "Pas de paperasse complexe pour vous"
    },
    whyUs: {
      title: "Pourquoi Choisir Elite?",
      features: [
        "Experts locaux en vitres d'auto",
        "Délais d'exécution rapides",
        "Qualité de travail garantie",
        "Service amical et professionnel",
        "Demandes de soumission faciles",
        "Emplacement pratique à Dorval"
      ]
    },
    areas: {
      title: "Fiers de Desservir",
      desc: "Dorval, Montréal, Lachine, Pointe-Claire, Ouest-de-l'Île, Laval et les régions environnantes."
    },
    cta: {
      title: "Besoin d'une réparation de vitre d'auto aujourd'hui?",
      subtitle: "Contactez-nous dès maintenant pour planifier votre rendez-vous ou obtenir une estimation gratuite."
    },
    contactPage: {
      title: "Contactez-Nous",
      subtitle: "Communiquez avec nous pour une soumission ou pour planifier votre service.",
      form: {
        name: "Nom Complet",
        phone: "Numéro de Téléphone",
        email: "Adresse Courriel",
        vehicle: "Marque / Modèle / Année du Véhicule",
        issue: "Type de Problème de Vitre",
        tireSize: "Dimension des Pneus",
        selectTireSize: "Sélectionner la dimension",
        insurance: "Est-ce une réclamation d'assurance?",
        yes: "Oui",
        no: "Non",
        other: "Autre",
        message: "Détails Supplémentaires",
        submit: "Envoyer la Demande",
        success: "Message envoyé! Nous vous contacterons sous peu."
      }
    },
    aboutPage: {
      title: "À Propos de Vitres D'Autos Elite",
      p1: "Situé au cœur de Dorval, Vitres D'Autos Elite offre des services de vitres d'auto de premier ordre aux communautés de Montréal et de l'Ouest-de-l'Île depuis des années.",
      p2: "Notre mission est simple : offrir une réparation et un remplacement de pare-brise sécuritaires, rapides et de haute qualité tout en rendant le processus aussi peu stressant que possible pour nos clients. Nous comprenons qu'une vitre brisée est un tracas inattendu, c'est pourquoi nous offrons une assistance transparente pour les réclamations d'assurance et un service efficace."
    },
    galleryPage: {
      title: "Notre Galerie de Travaux",
      subtitle: "Voyez la qualité de nos remplacements et réparations de vitres d'auto.",
      before: "Avant",
      after: "Après",
      openProject: "Voir le Projet",
      close: "Fermer",
      cases: [
        {
          title: "Réparation de Fissure de Pare-brise",
          location: "Dorval, Québec",
          desc: "Une fissure de pare-brise en progression a été stabilisée et réparée avant de nuire à la visibilité ou d'exiger un remplacement complet.",
          tags: ["Pare-brise", "Éclat", "Sécurité"]
        },
        {
          title: "Remplacement de Vitre Latérale",
          location: "Montréal, Québec",
          desc: "La vitre de porte brisée a été remplacée, les débris ont été nettoyés et le mécanisme a été vérifié.",
          tags: ["Vitre Latérale", "Nettoyage", "Remplacement"]
        },
        {
          title: "Rendez-vous Service de Pneus",
          location: "Ouest-de-l'Île, Québec",
          desc: "Installation saisonnière de pneus réservée au garage avec options de quincaillerie et TPMS vérifiées avant le service.",
          tags: ["Pneus", "TPMS", "Garage"]
        },
        {
          title: "Remplacement de Lunette Arrière",
          location: "Lachine, Québec",
          desc: "La vitre arrière endommagée a été remplacée et le véhicule a été nettoyé avec soin avant la remise.",
          tags: ["Lunette Arrière", "Nettoyage", "Remplacement"]
        },
        {
          title: "Service de Toit Ouvrant",
          location: "Pointe-Claire, Québec",
          desc: "Un problème de vitre de toit ouvrant a été inspecté et préparé pour un remplacement propre et sécuritaire.",
          tags: ["Toit Ouvrant", "Inspection", "Vitre"]
        },
        {
          title: "Mise à Niveau de Quincaillerie",
          location: "Dorval, Québec",
          desc: "Les options de quincaillerie ont été revues avec le client, incluant les écrous antivol, boulons noirs et capteurs TPMS.",
          tags: ["Quincaillerie", "TPMS", "Roues"]
        }
      ]
    },
    reviewsPage: {
      title: "Avis des Clients",
      subtitle: "Découvrez ce que nos clients de Montréal et de l'Ouest-de-l'Île ont à dire."
    },
    map: {
      title: "Trouver Vitres D'Autos Elite",
      openGoogle: "Ouvrir dans Google Maps"
    },
    legal: {
      privacyTitle: "Politique de Confidentialité",
      termsTitle: "Conditions d'Utilisation",
      updated: "Dernière mise à jour : 12 juin 2026",
      privacyIntro: "Vitres D'Autos Elite respecte votre vie privée. Cette politique explique comment les renseignements de contact et de rendez-vous peuvent être recueillis lorsque vous demandez une soumission ou un service.",
      privacyItems: [
        "Nous pouvons recueillir votre nom, numéro de téléphone, courriel, détails du véhicule, service demandé et message.",
        "Nous utilisons ces renseignements pour répondre aux demandes, planifier les rendez-vous et offrir le service à la clientèle.",
        "Nous ne vendons pas les renseignements personnels. Ils peuvent être partagés seulement avec des fournisseurs nécessaires aux opérations.",
        "Pour demander une mise à jour ou une suppression de vos renseignements, contactez-nous par téléphone ou courriel."
      ],
      termsIntro: "En utilisant ce site, vous acceptez ces conditions de base pour la navigation, les demandes de soumission et les demandes de rendez-vous.",
      termsItems: [
        "Le contenu du site est fourni à titre informatif et peut changer sans préavis.",
        "L'envoi d'un formulaire ne confirme pas un rendez-vous tant que l'entreprise ne vous a pas contacté.",
        "Les prix, disponibilités, protections contre les risques routiers et options de quincaillerie peuvent varier selon le véhicule, la dimension des pneus et le service requis.",
        "Les liens externes, y compris Instagram et Google, sont fournis par commodité et sont régis par leurs propres conditions."
      ]
    }
  }
};
